import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import rehypeRaw from 'rehype-raw';

type MarkdownPageProps = {
  content: string;
};

export default function MarkdownBlock({ content }: MarkdownPageProps) {
  return (
    <div
      className="
        prose-span:scroll-mt-36
        prose

        prose-sm
        max-w-none text-base

        leading-relaxed
        prose-h1:mb-0
        prose-h1:mt-0
        prose-h1:scroll-mt-36

        prose-h1:text-center
        prose-h1:text-[30px]
        prose-h2:mb-1
        prose-h2:mt-5
        prose-h2:scroll-mt-36
        prose-h3:mb-1
        prose-h3:mt-5
        prose-h3:scroll-mt-36
        prose-p:my-4

        prose-strong:font-semibold
        prose-ul:my-1
        prose-li:my-1
        
        prose-table:w-full
        prose-table:max-w-full
        prose-table:table-fixed
        prose-table:border
        prose-table:border-black
        prose-table:pl-0
        
        prose-table:pr-0
        prose-table:text-base
        prose-table:prose-ul:my-0
        prose-table:prose-ul:pl-4
        prose-table:prose-li:my-0
        prose-th:break-words

        prose-th:border
        prose-th:border-black
        prose-th:px-3
        prose-th:py-2
        prose-th:align-top

        prose-th:text-base
        prose-table:prose-th:my-1
        prose-td:break-words
        prose-td:border
      prose-td:border-black
        prose-td:px-3
        prose-td:py-2
        prose-td:text-base
        "
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSlug, rehypeRaw]}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
